import * as Yup from 'yup';
import { Dto } from "../../../parts/crud/dto";




export class profileDto extends Dto {
  constructor() {
    super();
    this.data.initialValues = {
      firstname: '',

      lastname: '',
      email: '',

      password: '',
      password_confirm: ''
    };
    this.data.onSubmit = async (values: any) => {
      let result = await this._handleOnSubmitCustom(values, "/me");
    
      return result;
    }

    this.data.validationSchema = Yup.object({
      firstname: Yup.string().required('Il campo nome è obbligatorio'),
      lastname: Yup.string().required('Il campo congome obbligatorio'),
      email: Yup.string().email('Indirizzo email non valido').required('Il campo email è obbligatorio'),
     
      password: Yup.string().min(9, 'La password deve essere di almeno 9 caratteri'),
      password_confirm: Yup.string().oneOf([Yup.ref('password')], 'Le password non corrispondono')
    })
  }



  
}